import apiService from './api.service';

export interface Log {
  id: string;
  application_id: string;
  timestamp: number;
  level: 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'fatal';
  message: string;
  source?: string;
  trace_id?: string;
  span_id?: string;
  attributes?: object;
  stack_trace?: string;
  created_at: string;
}

export interface LogQueryParams {
  startTime?: number;
  endTime?: number;
  level?: string;
  search?: string;
  traceId?: string;
  limit?: number;
  offset?: number;
}

class LogApi {
  async getAll(
    applicationId: string,
    params?: LogQueryParams
  ): Promise<{ success: boolean; data: Log[]; meta: { total: number; limit: number; offset: number } }> {
    return apiService.get(`/v1/logs/applications/${applicationId}`, { params });
  }

  async getById(applicationId: string, id: string): Promise<{ success: boolean; data: Log }> {
    return apiService.get(`/v1/logs/applications/${applicationId}/${id}`);
  }

  async getStatistics(
    applicationId: string,
    startTime: number,
    endTime: number
  ): Promise<{ success: boolean; data: any }> {
    return apiService.get(`/v1/logs/applications/${applicationId}/statistics`, {
      params: { startTime, endTime },
    });
  }
}

export default new LogApi();
